const StartSpeechRecognition = ({
  setIsDictating,
  dictatedFinalRef,
  setInterimTranscript,
  dictationBaseRef,
  setNewComment,
  isRecordingRef,
  recognitionRef,
}) => {
  try {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
    if (!SpeechRecognition) {
      return
    }
    const recognition = new SpeechRecognition()
    recognition.lang = 'es-ES'
    recognition.interimResults = true
    recognition.continuous = true

    recognition.onstart = () => {
      setIsDictating(true)
    }

    recognition.onresult = (event) => {
      let interim = ""
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const result = event.results[i]
        const transcript = (result[0].transcript || "").trim()
        if (!transcript) continue
        if (result.isFinal) {
          // Acumular frase final y anexarla al texto existente (respetando ediciones del usuario)
          dictatedFinalRef.current = [dictatedFinalRef.current, transcript].filter(Boolean).join(' ').trim()
          setNewComment((prev) => (prev ? `${prev} ${transcript}` : transcript))
        } else {
          interim += (interim ? ' ' : '') + transcript
        }
      }
      // Mostrar interino solo como vista previa, no modificar el textarea
      setInterimTranscript(interim)
    }

    recognition.onerror = () => {
      setIsDictating(false)
      // Reintentar si seguimos grabando
      if (isRecordingRef?.current) {
        try { recognition.start() } catch {}
      }
    }

    recognition.onend = () => {
      // Si aún seguimos grabando, reintentar para experiencia continua
      if (isRecordingRef?.current) {
        try { setTimeout(() => recognition.start(), 150) } catch {}
      } else {
        setIsDictating(false)
        setInterimTranscript("")
      }
    }

    recognition.start()
    recognitionRef.current = recognition
    setIsDictating(true)
  } catch (e) {
    // Silencioso si no está soportado
  }
}

export default StartSpeechRecognition